import { RecaptchaV3Adapter } from './recaptcha-v3.adapter';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { InterceptorUtil, OccEndpointsService, USE_CLIENT_TOKEN } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class OccRecaptchaV3Adapter implements RecaptchaV3Adapter {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) {}

  checkResponse(response: string): Observable<boolean> {
    const url = this.occEndpoints.buildUrl('recaptchaV3CheckResponse', {
      urlParams: { response },
    });

    let headers = new HttpHeaders();
    headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);

    return this.http.get<boolean>(url, { headers });
  }
}
